/** 통장·예산 등에서 쓰는 자금원천 코드 → 표시명 (은행·예산 API와 동일) */
const FUNDING_CODE_TO_NAME: Record<string, string> = {
  "04": "자부담",
  "05": "후원금",
  "06": "수익사업",
  "07": "보조금",
};

export function getFundingDisplayName(code: string | null | undefined): string {
  const c = code != null ? String(code).trim() : "";
  if (!c) return "";
  return FUNDING_CODE_TO_NAME[c] || c;
}
